import styled from "styled-components";
import {
  Title as SundayTitle,
  Body as SundayBody,
  Button as SundayButton,
} from "sunday-component";
import { color } from "src/styles/globals";
import { down } from "styled-breakpoints";
import { Card } from "antd";
import CustomizationInfoDialog from "src/components/Common/CustomizationInfoDialog";

export const ReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SubTitle = styled(SundayTitle).attrs({ level: 7 })``;

export const Body = styled(SundayBody).attrs({ level: 7 })<{ color?: string }>`
  color: ${(props) => props.color || color.charcoal10};
`;

export const ReportLabel = styled(SundayBody).attrs({ level: 8 })`
  color: ${color.carrotOrange03};
`;

export const ShareLinkContainer = styled.div<{ columnGap?: string }>`
  display: flex;
  column-gap: ${(props) => props.columnGap};
  align-items: end;
  ${down("sm")} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FlexHorizontalContainer = styled.div<{ columnGap?: string }>`
  display: flex;
  column-gap: ${(props) => props.columnGap};
`;

export const FlexVerticalContainer = styled.div<{
  rowGap?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.rowGap};
  ${down("sm")} {
    width: 100%;
  }
`;

export const Button = styled(SundayButton)`
  min-width: 194px;
  ${down("sm")} {
    width: 100%;
  }
`;

export const Describe = styled.div`
  display: flex;
  gap: 4px;
  cursor: pointer;
  width: fit-content;
`;

export const ReportCard = styled(Card)`
  border-radius: 16px;
  overflow: hidden;
  .ant-card-body {
    padding: 16px;
  }
  .ant-card-head-title {
    padding: 16px 0;
  }

  .ant-card-head {
    padding: 0 16px;
  }
`;

export const ContactButton = styled(Button)`
  padding: 0px;
  height: fit-content !important;
  min-width: fit-content !important;
  max-width: fit-content !important;
`;

export const FillBox = styled.div`
  border-radius: 4px;
  padding: 16px;
  background-color: ${color.charcoal01};
  height: 100%;
`;

export const DescriptionDialog = styled(CustomizationInfoDialog)`
  .ant-modal-body > div {
    padding: 24px;
    text-align: center;
  }
`;

export const CodeInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
